<!--本页为左侧下拉菜单-->
<template>
  <div id="operationsMgContainer">
    <el-container class="navRouter">
      <el-aside class="leftNav">
        <el-menu :default-active="activePath()" style="padding-top: 30px" router>
          <div v-for="(item, index) in navArr" :key="index" class="warp">
            <el-submenu v-if="item.children[0]" :index="item.path">
              <template slot="title" style="font-size: 16px">
                <img v-if="item.icon" :src="item.icon" alt="" />
                <span class="name">{{ item.name }}</span>
              </template>
              <el-menu-item v-for="(childrenItem, childrenIndex) in item.children" :key="childrenIndex" :index="childrenItem.path">
                <span slot="title">{{ childrenItem.name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.path">
              <img v-if="item.icon" :src="item.icon" alt="" />
              <span slot="title" class="name">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>

      <div class="rightContent">
        <el-main class="main">
          <router-view></router-view>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "NavMenu",

  data() {
    return {
      navArr: [
        {
          name: "标准模板维护",
          path: "/standard/standardTemplate",
          icon: require("@/CommonDP/assets/standard/template.png"),
          children: []
        },
        {
          name: "标准图框维护",
          path: "/standard/standardDrawingFrame",
          icon: require("@/CommonDP/assets/standard/frame.png"),
          children: []
        },
        {
          name: "字体样式维护",
          path: "/standard/standardFont",
          icon: require("@/CommonDP/assets/standard/font.png"),
          children: []
        },
        {
          name: "线型样式维护",
          path: "/standard/linearStyle",
          icon: require("@/CommonDP/assets/standard/linear.png"),
          children: []
        },
        {
          name: "revit样板维护",
          path: "/standard/revitMaintenance",
          icon: require("@/CommonDP/assets/standard/template.png"),
          children: []
        },
        {
          name: "标准图层维护",
          path: "/standard/standardLayer",
          icon: require("@/CommonDP/assets/standard/layer.png"),
          children: []
        },
        {
          name: "目录模板维护",
          path: "/standard/templateDirectory",
          icon: require("@/CommonDP/assets/standard/directory.png"),
          children: []
        },
        {
          name: "协作图层维护",
          path: "/standard/collaborationLayer",
          icon: require("@/CommonDP/assets/standard/layer.png"),
          children: []
        },
        {
          name: "电子图章维护",
          path: "/standard/stamp",
          icon: require("@/CommonDP/assets/standard/stamp.png"),
          children: []
        },
        {
          name: "电子签名维护",
          path: "/standard/signature",
          icon: require("@/CommonDP/assets/standard/signature.png"),
          children: []
        },
        {
          name: "图框字段",
          path: "/standard/frameField",
          icon: require("@/CommonDP/assets/standard/frame.png"),
          children: []
        },
        {
          name: "打印配置",
          path: "/standard/printConfiguration",
          icon: require("@/CommonDP/assets/standard/print.png"),
          children: [
            {
              name: "绘图仪配置文件",
              path: "/standard/configurationFile",
              children: []
            },
            {
              name: "绘图仪型号参数文件",
              path: "/standard/parameterFile",
              children: []
            },
            {
              name: "打印样式表",
              path: "/standard/styleSheet",
              children: []
            }
          ]
        }
      ]
    };
  },

  methods: {
    activePath() {
      if (this.$route.matched[3]) {
        return this.$route.matched[3].path;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#operationsMgContainer {
  background-color: #eff1f6;
  .leftNav {
    .el-menu-item {
      height: 36px !important;
      line-height: 36px !important;
      padding-left: 17px !important;
      margin-bottom: 12px !important;
      border-right: 2px solid #fff;
    }
    /deep/ .el-submenu__title {
      height: 36px !important;
      line-height: 36px !important;
      padding-left: 17px !important;
      margin-bottom: 12px !important;
      border-right: 2px solid #fff;
    }
  }
}
</style>
<style lang="stylus" scoped>
#operationsMgContainer {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;

  .navRouter {
    width: 100%;
    height: 100%;
    background-color: #eff1f6;

    .leftNav {
      width: 226px !important;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;

      /deep/ .el-menu {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border-right: 0;
      }

      .el-menu-item.is-active {
        background-color: rgba(85, 132, 255, 0.1) !important;
        color: #333;
      }

      .el-menu-item:hover {
        background-color: rgba(85, 132, 255, 0.1) !important;
      }

      .submenu__title:hover {
        background-color: rgba(85, 132, 255, 0.1) !important;
      }

      .el-menu-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;

        img {
          margin-right: 10px;
        }
      }

      .name {
        color: var(--key-color);
        font-size: 14px;
        line-height: 36px;
      }
    }

    .rightContent {
      flex: 1 1;
      height: 100%;
      overflow: hidden;

      .main {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0;
        padding-left: 10px;
      }
    }
  }
}
</style>
